export enum LanguageType {
    English = 'en',
    Arabic = 'ar',
}

export const LanguageDescriptions: Record<LanguageType, string> = {
    [LanguageType.English]: "English",
    [LanguageType.Arabic]: "Arabic",
};

export namespace LanguageType {
    export function toString(language: LanguageType): string {
        return language.toString();
    }

    export function getDescription(language: string | LanguageType): string {
        const lang: LanguageType = typeof language == 'string' ? language as LanguageType : language;
        return LanguageDescriptions[lang];
    }

    export function getLanguageCode(language: string | LanguageType): string {
        return LanguageMapper[language];
    }
}

const LanguageMapper: Record<string, string> = {
    [LanguageType.Arabic]: LanguageType.toString(LanguageType.Arabic),
    [LanguageType.getDescription(LanguageType.Arabic)]: LanguageType.toString(LanguageType.Arabic),
    [LanguageType.English]: LanguageType.toString(LanguageType.English),
    [LanguageType.getDescription(LanguageType.English)]: LanguageType.toString(LanguageType.English)
};